import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import AddFriendByNameAndMail from './addbynameemail.jsx'
import AddByCardNo from './addbycardno.jsx'
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux'
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
import '../../stylesheet/friends.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery'
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js';
const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    friendsState: state.getFriendsReducer.friendsState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchFriends() {
        dispatch(
            actions.getFriendsAction()
        )
    }
})


const JSEncrypt = window.JSEncrypt
class FriendsAndFamily extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            nickName: "",
            id: "",
            message: ""
        }
    }
    onChange = (e, value) => this.setState({ [e.target.name]: e.target.value })

    componentDidMount() {
        this.props.fetchFriends();
        let acc = document.getElementsByClassName("accordion");
        let i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                let panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 500 + "px";
                }
            });
        }
        $('.close').click(function () {
            $('#accordion .hide').slideUp();
        });
    }

    toggleAccordion() {

        let acc = document.getElementsByClassName("accordion");
        acc.classList.toggle("active");
        let panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + 500 + "px";
        }

    }
    handleDlt(id) {

        const { publicKey } = this.props

        // let _this = this
        let token = "Token " + localStorage.getItem('token')
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                friendDetailsId: encrypt.encrypt(id)
            }
            let _this = this
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.dlt_friend, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 500) {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                        } else if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.props.fetchFriends();
                        }
                    })
        }
    }
    handleEdit(id, nickName, firstName, lastName, message) {

        this.setState({
            id: id,
            firstName: firstName,
            lastName: lastName,
            nickName: nickName,
            message: message
        })


    }
    handleSubmit() {
        const { publicKey } = this.props

        // let _this = this
        let token = "Token " + localStorage.getItem('token')
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                friendDetailsId: encrypt.encrypt(this.state.id),
                nickName: encrypt.encrypt(this.state.nickName)
            }
            let _this = this
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.edit_friend, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 500) {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                        } else if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.props.fetchFriends();
                        }
                    })
        }
    }
    handleDownload() {
        const input = document.getElementById('divToPrint');
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'JPEG', 0, 0);
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            })
            ;
    }
    render() {
        const { firstName, lastName, nickName, message } = this.state

        const { friendsState } = this.props

        return (
            <div className="row" >
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="col-sm-12 m-0 p-0">
                    <AuthNavbar />
                </div>
                <div className="container" style={{}}>
                    <div className="row friends">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div> */}
                        <div className="modal fade" id="editfriend">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Edit</h5>
                                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                                    </div>


                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <div className="col-sm-1 input-icon" >
                                                        {/* <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                         <img src={creditcardlogo} alt="" /> */}
                                                    </div>
                                                    <div className="col-sm-3 nopadding " style={{ fontSize: "15px", fontWeight: "bold" }}>
                                                        <label>Card Name :</label>
                                                    </div>
                                                    <div className="col-sm-6 ">
                                                        <span> {firstName} {lastName}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-3">
                                                <div className="row" >
                                                    <div className="col-sm-1 input-icon" >
                                                        {/* <i className="fa fa-user text-dark " aria-hidden="true" style={{}}></i>
                                                        <img src={creditcardlogo} alt="" /> */}
                                                    </div>
                                                    <div className="col-sm-3 nopadding " style={{ fontSize: "15px", marginTop: "5px", fontWeight: "bold" }}>
                                                        <label style={{}}>Nickname :</label>
                                                    </div>
                                                    <div className="col-sm-6 nopadding" style={{ marginLeft: "28px", marginTop: "-33px" }}>
                                                        <div className="row" >
                                                            <TextField
                                                                floatingLabelText=" "
                                                                type="text"
                                                                style={{ borderColor: "white", boxShadow: "none", color: "#212529" }} name="nickName"
                                                                maxLength="50"
                                                                autoComplete='none'
                                                                className="input-width"
                                                                value={nickName || null}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12" style={{ marginTop: "3px" }}>
                                                <div className="row">
                                                    <div className="col-sm-1 input-icon"  >
                                                        {/* <i className="fa fa-comment text-dark " aria-hidden="true"></i> */}
                                                    </div>
                                                    <div className="col-sm-3 nopadding" style={{ fontSize: "15px", paddingLeft: "0px", fontWeight: "bold" }}>
                                                        <label>Message :</label>
                                                    </div>
                                                    <div className="col-sm-6 ">
                                                        <span> {message}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-std" data-dismiss="modal" disabled={!this.state.nickName} onClick={this.handleSubmit.bind(this)}>Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>

                            <div className="row" style={{ padding: "12px 0px", minHeight: "350px" }}>

                                <div className="col-sm-12 mb-0 pb-0 clearfix" style={{ height: '80px' }}>
                                    <div className='row'>
                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                            <h4 className='logmainheading mainheading'>
                                                Card Transfer List
                                            </h4>
                                            <p>
                                                Manage your card to card transfers here. To add a new card to transfer to, click 'Add New Card'.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 card-activity mb-4">
                                    <button className="accordion">
                                        <div className="row">
                                            <div className="col-sm-6" style={{ padding: "10px 13px" }}>Add New Card by Email/Name</div>
                                            {/* <div className="col-sm-9">
                                                <div className="row">
                                                    <div className="col-sm-3 text-right" style={{ padding: "7px 13px" }}>
                                                        <b>Card Account</b>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <select className="form-control">
                                                            <option>RL3YRGMCABS ATM : 481381******5095      :      $0.00</option>
                                                        </select>
                                                    </div>
                                                </div>


                                            </div> */}
                                        </div>
                                    </button>
                                    <div className="panel">
                                        <div className="box-shadow-style" style={{ padding: "12px" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="header-style">
                                                        <h5>
                                                            Add Card
                                                        </h5>
                                                        <p>
                                                            Adding a card  is fast and easy. Enter a name or email address and click Search. Once you have found the card, click 'Add Card' to add to your list.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <AddFriendByNameAndMail />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button className="accordion" id="accactive">
                                        <div className="row">
                                            <div className="col-sm-6" style={{ padding: "10px 13px" }}>Add New Card by Card Number</div>
                                            {/* <div className="col-sm-9">
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        <select className="form-control">
                                                            <option>Today</option>
                                                            <option>Yesterday</option>
                                                            <option>Last Week</option>
                                                            <option>This Month</option>
                                                            <option>This Year</option>
                                                            <option>Last Month</option>
                                                            <option>Last 3 Month</option>
                                                            <option>Last 6 Month</option>
                                                            <option>Last 9 Month</option>
                                                            <option>Last 12 Month</option>
                                                            <option>Last 24 Month</option>
                                                            <option>Show All</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-2 text-right" style={{ padding: "7px 13px" }}>
                                                        <b>Show Me</b>
                                                    </div>
                                                    <div className="col-sm-7">
                                                        <div className="row">
                                                            <div className="col-sm-4">
                                                                <input type="radio" name="type" id="type1" />
                                                                <label htmlFor="type1" >All</label>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <input type="radio" name="type" id="type2" />
                                                                <label htmlFor="type2" >Debit</label>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <input type="radio" name="type" id="type3" />
                                                                <label htmlFor="type3" >Credit</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div> */}
                                        </div>
                                    </button>
                                    <div className="panel">
                                        <div className="box-shadow-style" style={{ padding: "12px" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="header-style">
                                                        <h5>
                                                            Add Card
                                                        </h5>
                                                        <p>
                                                            Sharing funds with your card is fast and easy. Fill in the card  Detail fields shown below and click 'Add Card '. It's as simple as that! Fields marked with * must be filled.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <AddByCardNo onClick={this.toggleAccordion.bind(this)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">

                                    <table className="table table-striped" id="divToPrint">
                                        <thead className='table-dark'>
                                            <tr>
                                                <th>Nickname</th>
                                                <th>Card Holder Name</th>
                                                <th>Card Number</th>
                                                <th>Created On</th>
                                                <th>Options	</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {friendsState.status === 200 ?
                                                friendsState.body.length !== 0 &&
                                                friendsState.body.map((value, i) =>
                                                    <tr key={i}>
                                                        <td id={friendsState.body[i].friendDetailsId}>{friendsState.body[i].nickName}</td>
                                                        <td>{friendsState.body[i].firstName + " " + friendsState.body[i].lastName}</td>
                                                        <td>{friendsState.body[i].cardNumber}</td>
                                                        <td>{friendsState.body[i].createdOn}</td>
                                                        <td className="tableaction" style={{ cursor: "pointer" }}>
                                                            <i className="fa fa-pencil-square-o" aria-hidden="true" data-toggle="modal" data-target="#editfriend" onClick={(e) => { this.handleEdit(friendsState.body[i].friendDetailsId, friendsState.body[i].nickName, friendsState.body[i].firstName, friendsState.body[i].lastName, friendsState.body[i].message) }} style={{ marginRight: 10 }}></i>
                                                            |
                                                            <i className="fa fa-trash" aria-hidden="true" onClick={(e) => { this.handleDlt(friendsState.body[i].friendDetailsId, friendsState.body[i].message) }} style={{ marginLeft: 10 }}></i></td>
                                                    </tr>

                                                )
                                                : <tr>

                                                </tr>
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
FriendsAndFamily.defaultsProps = {
    friendsState: {
        status: 400
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FriendsAndFamily);


// WEBPACK FOOTER //
// ./src/components/friends/friends.jsx